var exports = {
  "w": "CardFrame__1Wp4YM",
  "f": "DraggedCard__OxZ-2v",
};

module.exports = exports;
